export const EVENT_NAMES = Object.freeze({
  ARTIFACT_OPENED: 'artifact_opened',
  ARTIFACT_DOWNLOADED: 'artifact_downloaded',
  STUDENT_MESSAGE_SENT: 'student_message_sent',
});
